import { Components, Theme } from "@mui/material";

export const muiPopoverTheme = (
  theme: Theme,
): Pick<Components<Omit<Theme, "components">>, "MuiPopover"> => ({
  MuiPopover: {
    styleOverrides: {},
  },
});
